import { makeRequest } from 'utils/requestLogger';
// import store from 'store';

export default (submission_id) =>
  makeRequest('put', `/api/submissions/${submission_id}/by-pass-submission`);



// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/services/roundtable/byPassSubmission.js